import Vue from 'vue'
import Main from './main.vue'
const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数

let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const CustomRoleGroup = options => {
  return new Promise((resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      // 初始所选
      selectedDataInit: options.selectedData || {},
      campusId: options.campusId || '', // 校区id
      role: options.role, // 操作角色 家长：1  班主任：2  管理员：3
      corpName: options.corpName || '', // 钉钉机构名
      corpId: options.corpId || '', // 钉钉机构Id
      returnType: options.returnType || 0, // 返回值类型
      needReturn: options.needReturn || false, // 返回是否返回tag
      title: options.title // 要展示的弹框的title
    }

    // eslint-disable-next-line
    _options.close = function (result) {
      CustomRoleGroup.close()
        .then(() => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line
    _options.closeOnly = function () {
      CustomRoleGroup.close()
        .then(() => {
          resolve({
            ...options.selectedData
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({
      data: _options
    })

    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    document.body.appendChild(MInstance.dom) // 将dom插入body
    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
CustomRoleGroup.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // //销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

export default CustomRoleGroup
